import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import EmployeePasswordSetupPage from "@/pages/employee/EmployeePasswordSetupPage";

export const Route = createFileRoute("/employee_/setup-password")({
  head: () => pageHead("Set Employee Password", "Create your AKIVA employee password.", "/employee/setup-password", true),
  component: EmployeePasswordSetupPage,
});
